import { offRoadImage } from "@/mocks/homeData";
import { WHATSAPP_LINK } from "@/pages/home/constants";

export default function OffRoad() {
  return (
    <section id="passeio-4x4" className="relative py-6 md:py-9 bg-background-100 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto reveal">
          <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-6 bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5">
            <div className="w-full sm:w-40 md:w-52 flex-shrink-0">
              <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-200/70">
                <img
                  src={offRoadImage}
                  alt="Passeio 4x4 em Capitólio com uma Pajero Full atravessando um córrego de água cristalina"
                  title="Passeio 4x4 de Pajero Full em Capitólio | Eco Tour Turismo"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="flex-1 text-center sm:text-left">
              <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 text-secondary-900 px-2.5 py-1 text-[10px] md:text-[11px] font-semibold uppercase tracking-wide mb-2">
                <i className="ri-steering-2-line text-xs" />
                Também disponível
              </span>
              <h2 className="text-base md:text-xl font-heading font-bold text-primary-900 mb-1.5">
                Passeios 4x4 em Capitólio
              </h2>
              <p className="text-[11px] md:text-sm text-foreground-600 leading-relaxed mb-3">
                Explore as belezas naturais de Capitólio em um emocionante passeio off-road! Conheça
                cachoeiras, trilhas, mirantes e paisagens deslumbrantes do Mar de Minas, vivenciando momentos
                únicos de aventura e contato com a natureza. Uma experiência perfeita para quem busca
                diversão, emoção e cenários inesquecíveis!
              </p>
              <a
                href={WHATSAPP_LINK}
                data-whatsapp-cta
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-[11px] md:text-xs font-bold bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-base" />
                Saber mais
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}